/* eslint-disable */

// to use this in a SalesContentIndexUI app, set
// `window.salesContentIndexContentType` and
// `window.salesContentIndexFolderType` to the types of content to search for

(function () {
  if (!window.quickFetch || !window.salesContentIndexContentType) {
    return;
  }

  var PAGE_SIZE = 10;

  var contentType = window.salesContentIndexContentType;
  var folderType = window.salesContentIndexFolderType;

  var contentTypesArray = [contentType];
  if (folderType) {
    contentTypesArray.push(folderType);
  }

  function getPageQueryParams() {
    var queryParamArray = window.location.search.split('?');
    if (queryParamArray.length !== 2) {
      return {};
    }
    return queryParamArray[1].split('&').reduce(function (map, pairString) {
      var pairArray = pairString.split('=');
      var toAdd = {};

      const valueWithSpaces = pairArray[1].replace(/\+/g, ' ');
      toAdd[pairArray[0]] = decodeURIComponent(valueWithSpaces);
      return Object.assign({}, map, toAdd);
    }, {});
  }

  function getFilters(contentType, folderType, params) {
    var contentTypesArray = [contentType];
    if (folderType) {
      contentTypesArray.push(folderType);
    }

    var type = params.type || params.view;

    switch (type) {
      case 'createdByMe':
      case 'ownedByMe':
        return [
          {
            field: 'content_type',
            values: [contentType],
          },
          {
            field: 'user_id',
            values: ['MY_ID'],
          },
        ];
      case 'createdByMyTeam':
      case 'ownedByMyTeam':
        return [
          {
            field: 'content_type',
            values: [contentType],
          },
          {
            field: 'team_id',
            values: ['MY_TEAM_ID'],
          },
        ];
      case 'USER':
        return [
          {
            field: 'content_type',
            values: [contentType],
          },
          {
            field: 'user_id',
            values: [params.view],
          },
        ];
      case 'TEAM':
        return [
          {
            field: 'content_type',
            values: [contentType],
          },
          {
            field: 'team_id',
            values: [params.view],
          },
        ];
      case 'all':
      default: {
        if (params.q) {
          return [{ field: 'content_type', values: contentTypesArray }];
        }

        return [
          {
            field: 'content_type',
            values: contentTypesArray,
          },
          {
            field: 'folder_id',
            values: params.folder ? [params.folder] : [],
          },
        ];
      }
    }
  }

  var queryParams = getPageQueryParams();

  var query = queryParams.q || '';
  var pageNumber = queryParams.page || 1;

  var sorts =
    queryParams.field && queryParams.order
      ? [
          {
            field: queryParams.field,
            order: queryParams.order,
          },
        ]
      : [
          {
            field: 'name',
            order: 'ASC',
          },
        ];

  var filters = getFilters(
    window.salesContentIndexContentType,
    window.salesContentIndexFolderType,
    queryParams
  );

  var searchQuery = {
    contentTypesToHydrate: contentTypesArray,
    query: query,
    offset: (pageNumber - 1) * PAGE_SIZE,
    limit: PAGE_SIZE,
    sorts: query ? [] : sorts,
    filters,
  };

  window.quickFetch.makeEarlyRequest('index-search', {
    url: window.quickFetch.getApiUrl(
      '/salescontentsearch/v2/search/early',
      true
    ),
    type: 'POST',
    contentType: 'application/json',
    dataType: 'json',
    timeout: 12000,
    data: JSON.stringify(searchQuery),
    xhrFields: { withCredentials: true },
  });
})();

/* eslint-enable */


